




































import { Component, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import store, { StoreReports, LOGIN_CHECK_ENDPOINT } from "../store";
import localforage from "localforage";

@Component
export default class Main extends Vue {
  public storeReports = StoreReports;

  public handleClick(route: string) {
    this.$router.push(route);
  }

  public refresh(event: Event) {
    store.dispatch("getDataFromEndpoint", {
      reload: true,
      app: this,
      event
    });
  }
}
